<template>
  <div class="tree-body">
    <div class="tree-line" v-for="item of treeData" :key="item.id">
      <div class="tree-title">
        <span @click.stop="jump(item.id)" :class="item.id === id ? 'active' : ''" v-html="setTile(item.title.replace(/\s/g, ''))">
        </span>
        <img src="./arrow-down.png" v-if="levels[item.id]  && item.children && item.children.length" @click.stop="check(item)">
        <template v-else>
          <img src="./arrow-right.png" v-if="item.children && item.children.length" @click.stop="check(item)">
        </template>
      </div>
      <template v-if="levels[item.id]">
        <treeNode :nodeData="item.children" @jump="jump"></treeNode>
      </template>
    </div>
  </div>
</template>
<script>
import treeNode from './tree-node'
export default {
  components: {
    treeNode
  },
  props: {
    treeData: {
      type: Array,
      requied: true
    }
  },
  data () {
    return {
      id: '',
      levels: {}
    }
  },
  methods: {
    check (item) {
      if (this.levels[item.id]) {
        this.$set(this.levels, item.id, undefined)
      } else {
        this.$set(this.levels, item.id, item)
      }
    },
    setTile (title) {
      return title.replace('编', '编&nbsp;&nbsp;&nbsp;&nbsp;')
    },
    jump (id) {
      this.id = id
      this.$emit('jump', id)
    }
  }
}
</script>
<style lang="stylus" scoped>
.tree-body
  text-align left
  line-height 1.6
  .tree-title
    display flex
    justify-content space-between
    align-items center
    border-bottom 1px solid #e5e5e5
    padding 0.2rem 0
    span
      font-size 0.24rem
      font-weight 700
      width 100%
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
    .active
      color #007bff
    img
      flex-shrink 0
      width 0.3rem
      height 0.3rem
</style>
